import {Module} from "vuex-smart-module";
import QrServerState from "@/store/modules/qr-server/qr-server-state";
import QrServerGetters from "@/store/modules/qr-server/qr-server-getters";
import QrServerMutations from "@/store/modules/qr-server/qr-server-mutations";
import QrServerActions from "@/store/modules/qr-server/qr-server-actions";

export default new Module({
    state: QrServerState,
    getters: QrServerGetters,
    mutations: QrServerMutations,
    actions: QrServerActions
});
